import React, { FC, useCallback, useState } from 'react';
import { Tabs } from '@silverfort/sf-components';
import { ApplicationDetailsTab, ApplicationDetailsTabs } from '../../../common/aplicationDetailsTabs';
import { useHistory, useParams } from 'react-router-dom';
import { useGetApplicationById } from '../../../api/queries/useGetApplicationById';
import { ResourcesView } from '../resources/ResourcesView';
import { usePageLayout } from '../../../hooks/usePageLayout';
import { ApplicationHeader } from './ApplicationHeader';
import { ActiveDirectoryAccessProvider } from '../../../context';
import { ApplicationUsersView } from './ApplicationUsersView';

export const ApplicationPage: FC = () => {
    const [selectedTab, setSelectedTab] = useState(ApplicationDetailsTab.Users);

    const history = useHistory();
    const { appId } = useParams<{ appId: string }>();

    const { application, loading } = useGetApplicationById(appId);

    const back = useCallback(() => {
        history.push('/AccessAnalysis');
    }, [history]);

    usePageLayout('Application drill-down', back);

    return (
        <article className="h-[calc(100%-4rem)] w-[calc(100%-4rem)] bg-sf-white mt-16 ml-16 p-6 flex flex-col gap-2">
            <ActiveDirectoryAccessProvider>
                <ApplicationHeader application={application} loading={loading} />

                <div className="flex flex-col gap-4 h-full">
                    <Tabs onClick={setSelectedTab} selectedTab={selectedTab} tabs={ApplicationDetailsTabs} />

                    {selectedTab === ApplicationDetailsTab.Users && <ApplicationUsersView applicationId={appId} />}
                    {selectedTab === ApplicationDetailsTab.Resources && <ResourcesView applicationId={appId} />}
                </div>
            </ActiveDirectoryAccessProvider>
        </article>
    );
};
